import { TankCreateForm } from 'app/agriculture/routes/Tanks/TankCreate/components/TankCreateForm';

export function TankCreate() {
    return <TankCreateForm />;
}
